// Function to push events to dataLayer
function pushToDataLayer(eventName, eventData = {}) {
    dataLayer.push({
        ecommerce: null
    });
    window.dataLayer.push({
        'event': eventName,
        ...eventData
    });
}

function sendFormEvents(nameForm) {
    switch (nameForm) {
        case 'feedback':
            pushToDataLayer('send_form_feedback_footer');
            break;

        case 'appointment':
            pushToDataLayer('send_form_signup_service');
            break;

        case 'director':
            pushToDataLayer('send_form_director');
            break;

        case 'question':
            pushToDataLayer('send_form_ask_question');
            break;

        case 'callback':
            pushToDataLayer('send_form_callback');
            break;

        case 'subscribe':
            pushToDataLayer('send_form_subscribe');
            break;

        case 'appointment_specialist':
            pushToDataLayer('send_form_signup_service');
            break;

        case 'question_specialist':
            pushToDataLayer('send_form_ask_question');
            break;

        case 'action_form':
            pushToDataLayer('send_form_action');
            break;

        case 'morpheus8':
            pushToDataLayer('send_morpheus8');
            break;

        case 'review':
            pushToDataLayer('send_form_review');
            break;
    }
}

$(document).ready(function () {
    $(document).on('click', '[data-gtm]', function (e) {
        e.preventDefault();
        const eventName = $(this).attr('data-gtm');
        const href = $(this).attr('href');
        const target = $(this).attr('target');

        if (eventName) {
            pushToDataLayer(eventName);
            setTimeout(function () {
                if (href && href !== '#' && !href.startsWith('javascript:')) {
                    if (target === '_blank') {
                        window.open(href, '_blank');
                    } else {
                        window.location.href = href;
                    }
                }
            }, 200);
        }
    });

    $(document).on('copy', function (event) {
        const selection = window.getSelection().toString();
        if (selection.match(/^\+?\d[\d\s-]{8,}\d$/)) {
            pushToDataLayer('copy_phone');
        } else if (selection.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            pushToDataLayer('copy_mail');
        }
    });
});

window.pushToDataLayer = pushToDataLayer;
window.sendFormEvents = sendFormEvents;
